module.exports = __webpack_public_path__ + "img/visa.d173539f.svg";